/**
 * Formats a number as a currency string. With an option to show cents
 *
 * @param value - The number to format as currency.
 * @param roundToDollar - Currency cents should be rounded to dollar.
 * @returns The formatted currency string.
 */
const maskCurrency = (
  value: number,
  roundToDollar: boolean = false,
): string => {
  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: !roundToDollar ? 2 : 0,
    maximumFractionDigits: !roundToDollar ? 2 : 0,
  };
  return value.toLocaleString('en-US', options);
};

export default maskCurrency;
